<script setup></script>
<template>
  <main class="min-h-[100vh] w-full grow bg-gradient-to-b from-slate-100 to-slate-50 dark:bg-background dark:from-background dark:to-background">
    <div class="flex items-center justify-between border-b bg-card px-4 py-3 print:hidden">
      <p class="text-sm font-medium">{{ useUser().getUser.email }}</p>
      <Button variant="outline" size="sm" @click="useLogout" v-if="useUser().getUser.id">Logout</Button>
    </div>
    <div class="mx-auto flex max-w-7xl flex-col gap-6 p-4 lg:px-6 lg:py-8">
      <slot />
    </div>
  </main>
</template>
